export default "__VITE_ASSET__BZinGRRH__"